import * as React from "react"
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby"
import Navigation from "./Navigation/Navigation";
import Footer from "./../components/Footer/Footer"
import UserManagement from '../utils/usermanagement'
import ParentAPI from '../utils/parentapi'
import CookieConsent from "../utils/cookieconsent";
import Notification from './../utils/notification'
import Analytic from "../utils/analytic";
import LastLogin from "./lastlogin";

const query = graphql`
	query global {
		site {
			siteMetadata {
				defaultTitle: title
			}
		}
		prismicEepsCookieBanner {
			data {
				accept_label
				reject_label
				title
				image {
					localFile {
						...secondaryImage
					}
					alt
				}
				description {
					html
				}
			}
		}
	}
`

const Layout = ({ title, description, children, headerStyle, showGoogleCode }) => {

	const { site, prismicEepsCookieBanner } = useStaticQuery(query)
	const titleshare="Get your PhoneSmart License" 
	const Description="EE has created a course that teaches kids how to stay safe and be kind online."

	return (
		<div className="global-wrapper">
			<UserManagement>
			<ParentAPI>
				<Helmet htmlAttributes={{ lang: 'en'}}>
					<title>{title || site.siteMetadata.defaultTitle}</title>
					{ description && ( <meta property="og:description" content={description} />)}


					<meta property="og:title" content={titleshare} />
					<meta property="og:image" content={`${process.env.GATSBY_APP_DOMAIN}/Fb-shareimg.png`}/>
					<meta property="og:url" content={process.env.GATSBY_APP_DOMAIN}/>
					<meta property="og:description" content={Description}/>
					
					<meta name="twitter:card" content="summary"/>
					<meta property="og:site_name" content={title || site.siteMetadata.defaultTitle}/>
					<meta name="twitter:image:alt" content={title || site.siteMetadata.defaultTitle}/>
					<meta name="twitter:image" content={`${process.env.GATSBY_APP_DOMAIN}/Fb-shareimg.png`} />
					<meta name="twitter:description" content={Description}></meta>
					{ showGoogleCode && ( <meta name="google-site-verification" content="_h-5WOC7Q9OlzA2WnjWVODNX84mFsBg1ZThjUCQGjtk" /> )}
					

					{/* 
						<meta property="fb:app_id" content="your_app_id" />
						<meta name="twitter:site" content="@website-username" /> 
					*/}

				</Helmet>
				<LastLogin />
				<Analytic pageTitle={title || site.siteMetadata.defaultTitle}>
					<CookieConsent data={prismicEepsCookieBanner} >
						<Navigation headerStyle={headerStyle ? headerStyle : "" } pageTitle={title || site.siteMetadata.defaultTitle} />

						<Notification>
							<main>
								{children}
							</main>
						</Notification>	
						
						<Footer pageTitle={title || site.siteMetadata.defaultTitle} />
					</CookieConsent>
				</Analytic>
			</ParentAPI>
				</UserManagement>
		</div>
	)
}

export default Layout
